import { TextAlignJustify } from "lucide-react";
import { Badge } from "../../shadcn/badge";

const AllCategoriesButton = () => {
  return (
    <div className="cursor-pointer flex items-center gap-2 font-medium text-sm hover:text-main transition-all duration-300 ease-in-out">
      <TextAlignJustify size={18} />
      TÜM KATEGORİLER
      <Badge variant="destructive" size="sm">
        Yeni
      </Badge>
    </div>
  );
};

export default AllCategoriesButton;
